import React from 'react';
import PropTypes from 'prop-types';
import { FormGroup, Input, Label } from 'reactstrap';
import { getIn } from 'formik';

const FormNumberInput = ({
  className = '',
  inputClassName = '',
  label,
  name,
  value,
  placeholder,
  disabled,
  isShowLabel = true,
  touched,
  errors,
  onChange,
  onKeyDown,
  onFocus,
  onBlur,
  min,
  max,
  step,
  pattern
}) => {
  // const isError = touched && errors && touched[name] && errors[name];
  const fieldTouched = getIn(touched, name);
  const fieldError = getIn(errors, name);
  const isError = fieldTouched && fieldError;

  return (
    <FormGroup className={`${className} position-relative`}>
      {isShowLabel && <Label htmlFor={name}>{label}</Label>}
      <Input
        pattern={pattern || undefined}
        className={`form-control ${isError ? 'is-invalid' : ''} ${inputClassName}`}
        name={name}
        type="number"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onKeyDown={onKeyDown}
        onBlur={onBlur}
        onFocus={onFocus}
        disabled={disabled}
        min={min}
        max={max}
        step={step}
      />
      {isError && <span className="invalid-feedback">{fieldError}</span>}
    </FormGroup>
  );
};

// PropTypes validation
FormNumberInput.propTypes = {
  className: PropTypes.string,
  inputClassName: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  isShowLabel: PropTypes.bool,
  touched: PropTypes.object,
  errors: PropTypes.object,
  onChange: PropTypes.func,
  onKeyDown: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  min: PropTypes.number,
  max: PropTypes.number,
  step: PropTypes.number,
  pattern: PropTypes.any
};

export default FormNumberInput;
